import { useState } from "react";
import nodeinstance from "../../../../../nodeInstance";
import { useDispatch } from "react-redux";
import { setAppError } from "../../../../../store/userSlice";
import { IoMdClose } from "react-icons/io";
import { CgSpinner } from "react-icons/cg";

export default function UploadExpiryDate({
  View,
  setView,
  url,
  setTrigger,
  trigger,
}) {
  const [loading, setLoading] = useState(false);
  const [file, setFile] = useState();
  const dispatch = useDispatch();
  const [errorshow, setErrorShow] = useState();

  const submitHandler = async (e, fileData) => {
    const token = localStorage.getItem("nodeToken");

    console.log("fileData......", fileData, file);
    e.preventDefault();

    setLoading(true);
    try {
      const formData = new FormData();
      formData.append("file", file);
      const response = await nodeinstance.post(url, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });
      console.log("response to be printed in the console", response.data);
      if (response.status === 200) {
        if (response.data.error.length > 0) {
          setErrorShow(response.data.error);
        } else {
          setTrigger(!trigger);
          setView(false);
        }
        dispatch(
          setAppError({
            msg: `${response.data.success} employees updated successfully.`,
            color: "success",
          })
        );
      }
    } catch (err) {
      dispatch(
        setAppError({
          msg: `error while updating the data`,
          //   color: "success",
        })
      );
    }
  };

  return (
    <>
      <div
        className={`fixed z-50 top-0 left-0 min-w-full min-h-screen bg-black/50 justify-center items-center ${
          View ? "flex" : "hidden"
        }`}
      >
        <div className="max-w-lg w-full h-auto rounded-md bg-white/95 flex flex-col p-4 relative">
          <div className="flex justify-between items-center w-full">
            <h1
              className="text-md font-semibold cursor-pointer"
              onClick={() => {
                setView(false);
              }}
            >
              <IoMdClose />
            </h1>
          </div>
          {errorshow?.length > 0 ? (
            <>
              <ul>
                {errorshow.map((data, index) => (
                  <li key={index}>
                    <span>{`${data.Iqama_Number} - ${data.message}`}</span>
                  </li>
                ))}
              </ul>
            </>
          ) : (
            <div className="w-full overflow-y-auto max-h-[70vh]">
              <form onSubmit={(e) => submitHandler(e, file)} className="w-full">
                <div className="w-full flex flex-col gap-3 my-3 p-5">
                  <div className="form-control w-full ">
                    {/* <label className="label">
                      <span className="label-text">{title}</span>
                    </label> */}
                    <input
                      type="file"
                      className="file-input file-input-bordered w-full "
                      onChange={(e) => setFile(e.target.files[0])}
                      required
                      accept="application/xls, application/xlsx"
                    />
                  </div>
                  <div
                    className="flex gap-3 w-full justify-center"
                    style={{ margin: 2 }}
                  >
                    <button
                      type="submit"
                      className="p-3 bg-red text-white rounded-md w-full max-w-xs m-2 my-4 flex gap-3 justify-center items-center text-sm" // Decreased padding and font size
                    >
                      <p>Submit</p>
                      {loading ? <CgSpinner className="animate-spin" /> : ""}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          )}
        </div>
      </div>
    </>
  );
}
